export default __webpack_public_path__ + "static/media/IconDesc_CoolingSystem.64.6617bdaa.png";